/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует устаревший функционал управления услугами.
 * Услуги это составные части привилегии на квартиру, сейчас считаются устаревшими, использовать нужно привилегии, сделаны тут для совместимости
 */

/**
 * Сервис услуг
 */
export class ServiceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения услуг квартиры.
   * Вернёт все услуги на квартире и недоступные по адресу как неактивные.
   * Метод доступен для: admin, master, service, application(subscription:read или subscription:edit)
   */
  GetServiceList = (req: GetServiceListRequestDto, init?: RequestInit): Promise<GetServiceListResponseDto[]> => {
    return fm.list<GetServiceListRequestDto, GetServiceListResponseDto>(`${this.host}/subscription/api/v1/service/${encodeURIComponent(req.orpon)}/${encodeURIComponent(req.flatNumber)}/list${fm.buildQuery(req, ["orpon","flatNumber"])}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения списка услуг.
   * Вернёт все услуги на квартире и недоступные по адресу как неактивные.
   * Метод доступен для: admin, service
   */
  GetServicePrivilegeList = (req?: GetServicePrivilegeListRequestDto, init?: RequestInit): Promise<GetServicePrivilegeListResponseDto[]> => {
    return fm.list<GetServicePrivilegeListRequestDto, GetServicePrivilegeListResponseDto>(`${this.host}/subscription/api/v1/service/privilege/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества услуг.
   * Вернёт все услуги на квартире и недоступные по адресу как неактивные.
   * Метод доступен для: admin, service
   */
  GetServicePrivilegeCount = (req?: GetServicePrivilegeCountRequestDto, init?: RequestInit): Promise<GetServicePrivilegeCountResponseDto> => {
    return fm.request<GetServicePrivilegeCountRequestDto, GetServicePrivilegeCountResponseDto>(`${this.host}/subscription/api/v1/service/privilege/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения справочника видов услуг.
   * Метод доступен для: admin, service
   */
  GetServiceKindList = (req?: GetServiceKindListRequestDto, init?: RequestInit): Promise<GetServiceKindListResponseDto[]> => {
    return fm.list<GetServiceKindListRequestDto, GetServiceKindListResponseDto>(`${this.host}/subscription/api/v1/service/kind/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
}

/**
 * Справочник типов направлений сортировки.
 */
export enum ServicePrivilegePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type ServicePrivilegePagingDirectionTypeResponseEnum = keyof typeof ServicePrivilegePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type ServicePrivilegePagingDirectionTypeRequestEnum = Exclude<ServicePrivilegePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum ServicePrivilegePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По ОРПОНу, затем по номеру квартиры
   */
  ORPON_THEN_FLAT_NUMBER = "ORPON_THEN_FLAT_NUMBER",
}
/**
 * Справочник типов значений сортировки.
 */
export type ServicePrivilegePagingOrderByTypeResponseEnum = keyof typeof ServicePrivilegePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type ServicePrivilegePagingOrderByTypeRequestEnum = Exclude<ServicePrivilegePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения справочника видов услуг
 */
export type GetServiceKindListRequestDto = {
}
/**
 * Результат запроса получения справочника видов услуг
 */
export type GetServiceKindListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Элемент справочника услуг
   */
  readonly data: ServiceKindResponseDto
}>
/**
 * Запрос получения списка услуг квартиры
 */
export type GetServiceListRequestDto = {
  /**
   * ОРПОН.
   * Идентификатор дома
   */
  orpon: string
  /**
   * Номер квартиры
   */
  flatNumber: string
}
/**
 * Результат запроса получения списка услуг квартиры
 */
export type GetServiceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Услуга
   */
  readonly data: SeviceResponseDto
}>
/**
 * Запрос получения количества услуг
 */
export type GetServicePrivilegeCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: ServicePrivilegeFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: ServicePrivilegePagingRequestDto
}>
/**
 * Результат запроса получения количества услуг
 */
export type GetServicePrivilegeCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка услуг
 */
export type GetServicePrivilegeListRequestDto = {
  /**
   * Фильтр
   */
  filter?: ServicePrivilegeFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: ServicePrivilegePagingRequestDto
}>
/**
 * Результат запроса получения списка услуг
 */
export type GetServicePrivilegeListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Услуга
   */
  readonly data: ServiceResponseDto
}>
/**
 * Услуга
 */
export type ServiceRequestDto = {
  /**
   * Название услуги на английском
   */
  name?: string
  /**
   * Доступна ли услуга на квартире.
   * Вернётся true если статусы привилегии:
   * - PROMO;
   * - PAID;
   * - TURNS_OFF.
   * Вернётся false если статусы привилегии:
   * - NOT_PAID;
   * - CAN_BE_PAID;
   * - STATE_TYPE_UNKNOWN;
   * - Не найден (нет на кваритре, но есть в справочнике привилегий)
   */
  isActive?: boolean
  /**
   * ОРПОН дома
   */
  orpon?: string | null
  /**
   * Номер квартиры
   */
  flatNumber?: string | null
}
/**
 * Услуга
 */
export type ServiceResponseDto = {
  /**
   * Название услуги на английском
   */
  name: string
  /**
   * Доступна ли услуга на квартире.
   * Вернётся true если статусы привилегии:
   * - PROMO;
   * - PAID;
   * - TURNS_OFF.
   * Вернётся false если статусы привилегии:
   * - NOT_PAID;
   * - CAN_BE_PAID;
   * - STATE_TYPE_UNKNOWN;
   * - Не найден (нет на кваритре, но есть в справочнике привилегий)
   */
  isActive: boolean
  /**
   * ОРПОН дома
   */
  orpon: string | null
  /**
   * Номер квартиры
   */
  flatNumber: string | null
}
/**
 * Элемент справочника видов услуг
 */
export type ServiceKindRequestDto = {
  /**
   * Идентификатор услуги
   */
  id?: number
  /**
   * Категория услуги.
   * Аналогично V1ServiceDto.type
   */
  category?: string
  /**
   * Название услуги на английском
   */
  name?: string
  /**
   * Название услуги
   */
  title?: string
  /**
   * Описание услуги
   */
  description?: string | null
  /**
   * Идентификатор родительской услуги
   */
  parentId?: number | null
}
/**
 * Элемент справочника видов услуг
 */
export type ServiceKindResponseDto = {
  /**
   * Идентификатор услуги
   */
  id: number
  /**
   * Категория услуги.
   * Аналогично V1ServiceDto.type
   */
  category: string
  /**
   * Название услуги на английском
   */
  name: string
  /**
   * Название услуги
   */
  title: string
  /**
   * Описание услуги
   */
  description: string | null
  /**
   * Идентификатор родительской услуги
   */
  parentId: number | null
}
/**
 * Фильтр услуг
 */
export type ServicePrivilegeFilterRequestDto = {
  /**
   * По ОРПОН
   */
  orpons?: string[]
  /**
   * По номеру квартиры
   */
  flatNumbers?: string[]
}
/**
 * Фильтр услуг
 */
export type ServicePrivilegeFilterResponseDto = {
  /**
   * По ОРПОН
   */
  orpons: string[]
  /**
   * По номеру квартиры
   */
  flatNumbers: string[]
}
/**
 * Постраничный вывод
 */
export type ServicePrivilegePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_FLAT_NUMBER
   */
  orderByType?: ServicePrivilegePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: ServicePrivilegePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type ServicePrivilegePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_FLAT_NUMBER
   */
  orderByType: ServicePrivilegePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: ServicePrivilegePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Услуга.
 * TODO: deprecated
 */
export type SeviceRequestDto = {
  /**
   * Название услуги на английском
   */
  name?: string
  /**
   * Доступна ли услуга на квартире.
   * Вернётся true если статусы привилегии:
   * - PROMO;
   * - PAID;
   * - TURNS_OFF.
   * Вернётся false если статусы привилегии:
   * - NOT_PAID;
   * - CAN_BE_PAID;
   * - STATE_TYPE_UNKNOWN;
   * - Не найден (нет на кваритре, но есть в справочнике привилегий)
   */
  isActive?: boolean
}
/**
 * Услуга.
 * TODO: deprecated
 */
export type SeviceResponseDto = {
  /**
   * Название услуги на английском
   */
  name: string
  /**
   * Доступна ли услуга на квартире.
   * Вернётся true если статусы привилегии:
   * - PROMO;
   * - PAID;
   * - TURNS_OFF.
   * Вернётся false если статусы привилегии:
   * - NOT_PAID;
   * - CAN_BE_PAID;
   * - STATE_TYPE_UNKNOWN;
   * - Не найден (нет на кваритре, но есть в справочнике привилегий)
   */
  isActive: boolean
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения справочника видов услуг
   */
  "GetServiceKindListRequest": {
    "kind": "class",
    "text": "Запрос получения справочника видов услуг",
  },
  /**
   * Результат запроса получения справочника видов услуг
   */
  "GetServiceKindListResponse": {
    "kind": "class",
    "text": "Результат запроса получения справочника видов услуг",
    "fields": {
      /**
       * Элемент справочника услуг
       */
      "data": {
        "type": "ServiceKind",
        "text": "Элемент справочника услуг",
      },
    },
  },
  /**
   * Запрос получения списка услуг квартиры
   */
  "GetServiceListRequest": {
    "kind": "class",
    "text": "Запрос получения списка услуг квартиры",
    "fields": {
      /**
       * ОРПОН.
       * Идентификатор дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\nИдентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "flatNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Результат запроса получения списка услуг квартиры
   */
  "GetServiceListResponse": {
    "kind": "class",
    "text": "Результат запроса получения списка услуг квартиры",
    "fields": {
      /**
       * Услуга
       */
      "data": {
        "type": "Sevice",
        "text": "Услуга",
      },
    },
  },
  /**
   * Запрос получения количества услуг
   */
  "GetServicePrivilegeCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества услуг",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "ServicePrivilegeFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "ServicePrivilegePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Результат запроса получения количества услуг
   */
  "GetServicePrivilegeCountResponse": {
    "kind": "class",
    "text": "Результат запроса получения количества услуг",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос получения списка услуг
   */
  "GetServicePrivilegeListRequest": {
    "kind": "class",
    "text": "Запрос получения списка услуг",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "ServicePrivilegeFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "ServicePrivilegePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Результат запроса получения списка услуг
   */
  "GetServicePrivilegeListResponse": {
    "kind": "class",
    "text": "Результат запроса получения списка услуг",
    "fields": {
      /**
       * Услуга
       */
      "data": {
        "type": "Service",
        "text": "Услуга",
      },
    },
  },
  /**
   * Услуга
   */
  "Service": {
    "kind": "class",
    "text": "Услуга",
    "fields": {
      /**
       * Название услуги на английском
       */
      "name": {
        "type": "string",
        "text": "Название услуги на английском",
      },
      /**
       * Доступна ли услуга на квартире.
       * Вернётся true если статусы привилегии:
       * - PROMO;
       * - PAID;
       * - TURNS_OFF.
       * Вернётся false если статусы привилегии:
       * - NOT_PAID;
       * - CAN_BE_PAID;
       * - STATE_TYPE_UNKNOWN;
       * - Не найден (нет на кваритре, но есть в справочнике привилегий)
       */
      "isActive": {
        "type": "bool",
        "text": "Доступна ли услуга на квартире.\nВернётся true если статусы привилегии:\n- PROMO;\n- PAID;\n- TURNS_OFF.\nВернётся false если статусы привилегии:\n- NOT_PAID;\n- CAN_BE_PAID;\n- STATE_TYPE_UNKNOWN;\n- Не найден (нет на кваритре, но есть в справочнике привилегий)",
      },
      /**
       * ОРПОН дома
       */
      "orpon": {
        "type": "google.protobuf.Int64Value",
        "text": "ОРПОН дома",
      },
      /**
       * Номер квартиры
       */
      "flatNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер квартиры",
      },
    },
  },
  /**
   * Элемент справочника видов услуг
   */
  "ServiceKind": {
    "kind": "class",
    "text": "Элемент справочника видов услуг",
    "fields": {
      /**
       * Идентификатор услуги
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор услуги",
      },
      /**
       * Категория услуги.
       * Аналогично V1ServiceDto.type
       */
      "category": {
        "type": "string",
        "text": "Категория услуги.\nАналогично V1ServiceDto.type",
      },
      /**
       * Название услуги на английском
       */
      "name": {
        "type": "string",
        "text": "Название услуги на английском",
      },
      /**
       * Название услуги
       */
      "title": {
        "type": "string",
        "text": "Название услуги",
      },
      /**
       * Описание услуги
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание услуги",
      },
      /**
       * Идентификатор родительской услуги
       */
      "parentId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор родительской услуги",
      },
    },
  },
  /**
   * Фильтр услуг
   */
  "ServicePrivilegeFilter": {
    "kind": "class",
    "text": "Фильтр услуг",
    "fields": {
      /**
       * По ОРПОН
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОН",
      },
      /**
       * По номеру квартиры
       */
      "flatNumbers": {
        "type": "string",
        "text": "По номеру квартиры",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "ServicePrivilegePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ORPON_THEN_FLAT_NUMBER
       */
      "orderByType": {
        "type": "ServicePrivilegePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ORPON_THEN_FLAT_NUMBER",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "ServicePrivilegePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Услуга.
   * TODO: deprecated
   */
  "Sevice": {
    "kind": "class",
    "text": "Услуга.\nTODO: deprecated",
    "fields": {
      /**
       * Название услуги на английском
       */
      "name": {
        "type": "string",
        "text": "Название услуги на английском",
      },
      /**
       * Доступна ли услуга на квартире.
       * Вернётся true если статусы привилегии:
       * - PROMO;
       * - PAID;
       * - TURNS_OFF.
       * Вернётся false если статусы привилегии:
       * - NOT_PAID;
       * - CAN_BE_PAID;
       * - STATE_TYPE_UNKNOWN;
       * - Не найден (нет на кваритре, но есть в справочнике привилегий)
       */
      "isActive": {
        "type": "bool",
        "text": "Доступна ли услуга на квартире.\nВернётся true если статусы привилегии:\n- PROMO;\n- PAID;\n- TURNS_OFF.\nВернётся false если статусы привилегии:\n- NOT_PAID;\n- CAN_BE_PAID;\n- STATE_TYPE_UNKNOWN;\n- Не найден (нет на кваритре, но есть в справочнике привилегий)",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "ServicePrivilegePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "ServicePrivilegePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По ОРПОНу, затем по номеру квартиры
       */
      "ORPON_THEN_FLAT_NUMBER": {
        "i": 1,
        "text": "По ОРПОНу, затем по номеру квартиры",
      },
    },
  },
}